import { render, staticRenderFns } from "./reactivate_parent.vue?vue&type=template&id=26699f80&"
import script from "./reactivate_parent.vue?vue&type=script&lang=js&"
export * from "./reactivate_parent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports